import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useDropzone } from 'react-dropzone';
import Text from '../Text';
import { css, StyleSheet } from 'aphrodite/no-important';
import { DOVE_GRAY, ALTO, CENTER, LOCHMARA } from '../../styles';
import Icon from '../Icon';

const s = StyleSheet.create({
  root: {
    position: 'relative',
    display: 'block',
    width: '100%',
    marginBottom: 12,
    color: DOVE_GRAY,
  },
  dropZone: {
    display: 'flex',
    alignItems: CENTER,
    justifyContent: CENTER,
    width: '100%',
    outline: 0,
    fontSize: 16,
    padding: '8px 11px',
    borderRadius: 2,
    border: `2px dashed ${ALTO}`,
    cursor: 'pointer',
  },
  preview: {
    maxWidth: '100%',
    minWidth: '100%',
  },
  delete: {
    display: 'block',
    appearance: 'none',
    borderWidth: 0,
    padding: 0,
    outline: 0,
    textDecoration: 'underline',
    backgroundColor: 'transparent',
    cursor: 'pointer',
    ':hover': {
      color: LOCHMARA,
    },
  },
  plus: {
    width: 17,
    height: 17,
    cursor: 'pointer',
    marginTop: 5,
  },
  previewWrapper: {
    position: 'relative',
    lineHeight: 0,
    ':after': {
      position: 'absolute',
      content: '""',
      top: 0,
      left: 0,
      bottom: 0,
      rigth: 0,
      width: '100%',
      height: '100%',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      backgroundImage: `url(${require('../../assets/BE_profile_thumb_new.png')})`,
    },
  },
});

const onFileChange = (onChange) => {
  return (acceptedFiles) => {
    const reader = new FileReader();
    // eslint-disable-next-line no-console
    reader.onabort = () => console.warn('file reading was aborted');
    // eslint-disable-next-line no-console
    reader.onerror = () => console.error('file reading has failed');
    reader.onload = () => {
      const binaryStr = reader.result;
      onChange({ value: binaryStr });
    };

    acceptedFiles.forEach((file) => reader.readAsDataURL(file));
  };
};

const FileInput = ({ accept, label, value, onChange }) => {
  const onDrop = useCallback(onFileChange(onChange), []);
  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: accept,
  });

  return (
    <div className={css(s.root)}>
      {!value && (
        <div {...getRootProps()} className={css(s.dropZone)}>
          <input {...getInputProps()} />
          <Icon name="plus" __className={s.plus} />
          <Text messageId={label || 'app.file.input.default'} />
        </div>
      )}
      {!!value && (
        <div className={css(s.previewWrapper)}>
          <img src={value} alt="Preview" className={css(s.preview)} />
        </div>
      )}
      {!!value && (
        <Text
          className={css(s.delete)}
          messageId="app.file.input.default.delete"
          component="button"
          type="button"
          onClick={() => onChange({ currentTarget: { value: '' } })}
        />
      )}
    </div>
  );
};

FileInput.propTypes = {
  accept: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
};

FileInput.defaultProps = {
  accept: 'image/*',
};

export default FileInput;
